import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from "@ngx-translate/core";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'telio-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
})
export class InputComponent implements OnInit, OnDestroy {

  @Input() inputLabel = '';
  @Input() minLength = 0;
  @Input() maxLength = 0;
  @Input() value?: string;
  @Input() required: false;
  @Input() width?: string;
  @Input() disabled = false;

  @Output()
  valueChange = new EventEmitter<string>();
  textInputControl: UntypedFormControl;
  constructor(public translate: TranslateService) {
    this.textInputControl = new UntypedFormControl('');
  }

  ngOnInit(): void {
    this.disabled && this.textInputControl.disable()
    this.textInputControl.valueChanges
      .pipe(debounceTime(100), distinctUntilChanged())
      .subscribe((data) => {
        !!data && this.change(data);
      })

    !!this.value && this.textInputControl.setValue(this.value)
  }

  public propagateChange: any = () => { };

  public propagateTouched: any = () => { };

  private change = (data: any) => {
    this.propagateChange(data);
    if (this.valueChange) this.valueChange.emit(data);
  };

  writeValue(obj: any): void {
    this.textInputControl.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouched = fn;
  }
  ngOnDestroy(): void { }
}
